export enum EnvironmentType {
    LOCAL = 'local',
    DEVELOPMENT = 'development',
    TESTING = 'testing',
    PRODUCTION = 'production',
}
